enum LenUnitsEnum {
  "MILLIMETERS" = 1,
  "CENTIMETERS" = 2,
  "METERS" = 3,
  "FEET" = 4,
}

export default LenUnitsEnum;
